import {FilterState} from './Preset';

export type Filters = Record<string, FilterState>;
